import { ready } from 'jquery';
import UIkit from 'uikit';
import Lenis from 'lenis';

// SCROLL
const lenis = new Lenis({lerp: 0.07})

lenis.on('scroll', (e) => {
  updateScrollControlledAnimations();
});

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

UIkit.util.on('[data-uk-modal]', 'show', function (e) {
  lenis.stop();
});
UIkit.util.on('[data-uk-modal]', 'hide', function (e) {
  lenis.start();
});
$(document).on('beforescroll', "body", function() {
  lenis.stop();
  lenis.start();
});

// SCROLL TO HASH
function scrollToHash() {
  var hash = window.location.hash;
  if (hash) {
      var target = jQuery(hash);
      if (target.length) {
          UIkit.scroll(target).scrollTo(target);
      }
  }
}
// ANIM SVG
var animation = new Array();
const animationObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const anim = animation.find(a => a && a.element === entry.target);
    if (anim) {
      anim.isInView = entry.isIntersecting;
    }
  });
});

function loadBMAnimation(element, i) {
  import('lottie-web').then((lottieModule) => {
    const lottieWeb = lottieModule.default;

    let currentAnimationData = {
      lottie: null,
      element: element,
      isScrollControlled: Boolean($(element).data('scroll')) === true,
      isInView: false
    };

    if (currentAnimationData.isScrollControlled) {
      animationObserver.observe(element);
      const lottieParams = {
        name: 'animation_scroll_' + i,
        container: element,
        renderer: "svg",
        loop: false,
        autoplay: false,
        path: $(element).data('path')
      };
      if ($(element).attr('data-preserveaspectratio')) {
        lottieParams.rendererSettings = { preserveAspectRatio: $(element).data('preserveaspectratio') };
      }
      currentAnimationData.lottie = lottieWeb.loadAnimation(lottieParams);

      currentAnimationData.lottie.addEventListener('DOMLoaded', function () {
        $(element).addClass('--loaded');
        if (currentAnimationData.lottie.totalFrames > 0) {
          currentAnimationData.lottie.goToAndStop(0, true);
        }
      });

    } else {
      var reverseLoop = Boolean($(element).data('reverseloop'));
      let dir = 1;
      var loopSetting = reverseLoop ? false : Boolean($(element).data('loop'));
      var hoverSetting = Boolean($(element).data('hover'));
      var repeatSetting = hoverSetting ? false : Boolean($(element).data('repeat'));

      var animation_params = {
        name: 'animation_' + i,
        container: element,
        renderer: "svg",
        loop: loopSetting,
        autoplay: Boolean($(element).data('autoplay')),
        path: $(element).data('path')
      };
      if ($(element).attr('data-preserveaspectratio')) {
        animation_params['rendererSettings'] = { preserveAspectRatio: $(element).data('preserveaspectratio') };
      }
      currentAnimationData.lottie = lottieWeb.loadAnimation(animation_params);

      var util = UIkit.util;
      var el = util.$(element);
      UIkit.scrollspy(el, { repeat: true });

      if (!hoverSetting) {
        util.on(el, 'inview', function () {
          currentAnimationData.lottie.play();
        });
      }

      if (repeatSetting) {
        util.on(el, 'outview', function () {
          currentAnimationData.lottie.stop();
        });
      }

      currentAnimationData.lottie.addEventListener('DOMLoaded', function () {
        $(element).addClass('--loaded');
      });
      currentAnimationData.lottie.addEventListener('enterFrame', function (event) {
        if (event.currentTime < 1 && !$(element).hasClass('--playing')) {
          $(element).addClass('--playing');
        }
      });

      currentAnimationData.lottie.addEventListener('complete', function () {
        $(element).removeClass('--playing');
        if (!loopSetting) {
          $(element).addClass('--finish');
        }
        if (reverseLoop) {
          if (dir == 1) { dir = '-1'; } else { dir = '1'; }
          currentAnimationData.lottie.setDirection(dir);
          currentAnimationData.lottie.play();
        }
      });
      currentAnimationData.lottie.addEventListener('loopComplete', function () {
        $(element).removeClass('--playing');
        void $(element)[0].offsetWidth;
        $(element).addClass('--playing');
      });

      if (hoverSetting) {
        $($(element).data('hover')).on('mouseenter', function () {
          currentAnimationData.lottie.pause();
          currentAnimationData.lottie.setDirection(1);
          currentAnimationData.lottie.play();
        });

        $($(element).data('hover')).on('mouseleave', function () {
          currentAnimationData.lottie.pause();
          currentAnimationData.lottie.setDirection(-1);
          currentAnimationData.lottie.play();
        });
      }
    }
    animation[i] = currentAnimationData;
  });
}

function updateScrollControlledAnimations() {
  const windowHeight = window.innerHeight;

  for (let i = 0; i < animation.length; i++) {
    const animData = animation[i];
    if (animData && animData.isScrollControlled && animData.lottie && animData.lottie.isLoaded && animData.lottie.totalFrames > 0 && animData.isInView) {
      const lottieInstance = animData.lottie;
      const element = animData.element;
      const rect = element.getBoundingClientRect();
      const elementTop = rect.top;
      const elementHeight = rect.height;

      if (elementHeight === 0 && windowHeight === 0) continue;

      const startAnimationTop = windowHeight;
      const endAnimationTop = -elementHeight;

      let progress = 0;
      const scrollDuration = startAnimationTop - endAnimationTop;

      if (elementTop <= endAnimationTop) {
        progress = 1;
      } else if (elementTop >= startAnimationTop) {
        progress = 0;
      } else {
        if (scrollDuration > 0) {
          progress = (startAnimationTop - elementTop) / scrollDuration;
        } else {
          progress = 0;
        }
      }

      progress = Math.max(0, Math.min(1, progress));

      const currentFrame = Math.round(progress * (lottieInstance.totalFrames - 1));
      lottieInstance.goToAndStop(currentFrame, true);

      if (progress > 0 && progress < 1) {
        $(element).addClass('--scrolling');
      } else {
        $(element).removeClass('--scrolling');
      }
    }
  }
}

$(function() {
  //load all animations json
  var element = document.getElementsByClassName("js_animation");

  for (var i = 0; i < element.length; i++) {
    loadBMAnimation(element[i],i);
  }

  //fix scroll to hash Lenis using Uikit
  scrollToHash();
});
